import "react-loading-skeleton/dist/skeleton.css";

import {
  GlobalStyle,
  theme,
} from "@waldner-laboreinrichtungen/component-system";
import * as i18n from "i18next";
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { initReactI18next } from "react-i18next";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";

import translationEcoRecommendationsDE from "../public/locales/de/eco-recommendations.json";
import translationIncidentsDE from "../public/locales/de/incidents.json";
import translationDE from "../public/locales/de/translation.json";
import translationEcoRecommendationsEN from "../public/locales/en/eco-recommendations.json";
import translationIncidentsEN from "../public/locales/en/incidents.json";
import translationEN from "../public/locales/en/translation.json";
import translationEcoRecommendationsES from "../public/locales/es/eco-recommendations.json";
import translationIncidentsES from "../public/locales/es/incidents.json";
import translationES from "../public/locales/es/translation.json";
import translationEcoRecommendationsFR from "../public/locales/fr/eco-recommendations.json";
import translationIncidentsFR from "../public/locales/fr/incidents.json";
import translationFR from "../public/locales/fr/translation.json";
import App from "./app.tsx";
import { AuthProvider } from "./auth-provider";
import { ErrorScreenWithText } from "./partials/error-screen";
import { LoadingScreenWithText } from "./partials/loading-screen";

export const resources = {
  en: {
    translation: translationEN,
    incidents: translationIncidentsEN,
    eco: translationEcoRecommendationsEN,
  },
  de: {
    translation: translationDE,
    incidents: translationIncidentsDE,
    eco: translationEcoRecommendationsDE,
  },
  es: {
    translation: translationES,
    incidents: translationIncidentsES,
    eco: translationEcoRecommendationsES,
  },
  fr: {
    translation: translationFR,
    incidents: translationIncidentsFR,
    eco: translationEcoRecommendationsFR,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "de", // if you're using a language detector, do not define the lng option
  fallbackLng: "en",

  interpolation: {
    escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
  },
});

ReactDOM.createRoot(document.querySelector("#root") as HTMLElement).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <BrowserRouter>
        <AuthProvider
          ErrorScreen={ErrorScreenWithText}
          LoadingScreen={LoadingScreenWithText}
        >
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
